import { IS_PROD_APP_ENV } from 'Utilities/constants';

const HIGH_DEMAND_MODEL_IDS_BY_MAKE = Object.freeze({
  Audi: [79, 81, 82, 83, 84, 92, 93, 94, 95, 107, 115],
  BMW: [199, 200, 201, 202, 207, 208, 210],
  Fiat: [478],
  Ford: [538, 539, 550, 574],
  Honda: [607, 639],
  Hyundai: [714, 732],
  Kia: [813],
  'Land Rover': [850, 851],
  MINI: [1059, 1060],
  Nissan: [1146, 1169],
  Peugeot: [1226, 1227],
  SEAT: [1428, 1430],
  Skoda: [1452],
  Toyota: [1550, 1594],
  Vauxhall: [1636, 1645, 1655],
  Volkswagen: [1706, 1724, 1730],
  Volvo: [1790, 1792],
});

const VOLVO_XC40_MODEL_ID_BY_APP_ENV = Object.freeze({
  nonProduction: 2183,
  production: 2204,
});

export const getHighDemandModelIds = (isProdAppEnv: boolean): ReadonlySet<number> => new Set([
  ...Object.values(HIGH_DEMAND_MODEL_IDS_BY_MAKE).flat(),
  isProdAppEnv
    ? VOLVO_XC40_MODEL_ID_BY_APP_ENV.production
    : VOLVO_XC40_MODEL_ID_BY_APP_ENV.nonProduction,
]);

export const HIGH_DEMAND_MODEL_IDS: ReadonlySet<number> = getHighDemandModelIds(IS_PROD_APP_ENV);

export const isHighDemandModelId = (modelId?: number | null): boolean =>
  typeof modelId === 'number' && HIGH_DEMAND_MODEL_IDS.has(modelId);
